export function getRenderedBackendAgentFieldIds(
  layoutRoot: HTMLElement,
  candidateFieldIds: readonly string[]
): ReadonlySet<string> {
  const candidateFieldIdSet = new Set(candidateFieldIds);
  const renderedFieldIds = new Set<string>();

  for (const element of layoutRoot.querySelectorAll<HTMLElement>('th[data-field-id]')) {
    const fieldId = element.getAttribute('data-field-id');
    if (!fieldId || !candidateFieldIdSet.has(fieldId)) {
      continue;
    }

    const rect = element.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      renderedFieldIds.add(fieldId);
    }
  }

  return renderedFieldIds;
}
